
export function getClipboard(text) {
  const el = document.createElement("textarea");
  el.value = text;
  document.body.appendChild(el);
  const range = document.createRange();
  range.selectNode(el);
  window.getSelection().addRange(range);
  document.execCommand("copy");
  const value = el.value;
  document.body.removeChild(el);
  window.getSelection().removeAllRanges();
  return value;
}
